import React from 'react';
import { NavLink } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

const Sidebar = () => {
  const menuItems = [
    {
      name: 'Dashboard',
      path: '/dashboard',
    },
    {
      name: 'Patients',
      path: '/patients',
    },
    {
      name: 'Appointments',
      path: '/appointments',
    },
    {
      name: 'Treatments',
      path: '/treatments',
    },
    {
      name: 'Finance',
      path: '/finance',
    },
    {
      name: 'Analytics',
      path: '/analytics',
    },
    {
      name: 'Notes',
      path: '/notes',
    },
      {
    name: 'Contact Requests',  // ADD THIS
    path: '/contact-requests',
  },
  ];

  return (
    <div className="w-64 bg-gray-800 min-h-screen flex flex-col">
      <div className="px-6 py-6 border-b border-gray-700">
        <h1 className="text-2xl font-bold text-white">Keshav Care</h1>
        <p className="text-sm text-gray-400 mt-1">Admin Panel</p>
      </div>

      <div className="py-4 flex-1">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center justify-between px-6 py-3 text-gray-300 hover:bg-gray-700 hover:text-white transition-colors ${
                isActive ? 'bg-gray-700 text-white border-l-4 border-indigo-500' : ''
              }`
            }
          >
            <div className="flex items-center space-x-3">
              <span className="text-xl">{item.icon}</span>
              <span className="font-medium">{item.name}</span>
            </div>
          </NavLink>
        ))}
      </div>

      <div className="border-t border-gray-700 py-4">
        <a
          href="//www.keshavcare.com"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-between px-6 py-3 text-gray-300 hover:bg-gray-700 hover:text-white transition-colors"
        >
          <div className="flex items-center space-x-3">
            <span className="font-medium">Public Website</span>
          </div>
          <ExternalLink className="w-4 h-4" />
        </a>
      </div>
    </div>
  );
};

export default Sidebar;